import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitClass'
})
export class LimitClassPipe implements PipeTransform {

ExcludedComponentList=['roaming-must-know'];

  transform(id:any): any {
    let isValid= this.ExcludedComponentList.includes(id);
    return (isValid ? '' : 'aem-spa-wrap');
  }

}
